import React from 'react';
import { Trans } from 'react-i18next';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import s from './CoreExclusive.scss';

const CoreExclusive: React.FC<{}> = () => (
  <div className={s['root']}>
    <Trans i18nKey={'pages.shop.emptyState.nonCore.premiumFolder.exclusive'}>
      <CoreBadge size="large" className={s['core-badge']} /> Exclusive
    </Trans>
  </div>
);
CoreExclusive.displayName = 'CoreExclusive';

export default CoreExclusive;
